import { useSnackbar } from "notistack";
import {
  syncMarkingDataPeriodicalReportMarkingById as syncMarkingDataPeriodicalReportMarkingByIdService,
  syncMarkingDataPeriodicalReportMarkingByIdAndAssessmentArea as syncMarkingDataPeriodicalReportMarkingByIdAndAssessmentAreaService,
} from "../../services/periodical-report/periodical-report-marking.service.js";
import { validate } from "../../utils/index.js";
import { handlerErrorV2 } from "../../utils/errors.jsx";
import isEmpty from "lodash/isEmpty";
import { useParams } from "react-router-dom";
import { toggleAlertInfo } from "../../store/actions/alert.actions.js";
import { useDispatch } from "react-redux";

const usePeriodicalReporMarking = () => {
  const { periodicalReportId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const validateForm = (form, type) => {
    let fieldRules = {};

    if (["sync"].includes(type)) {
      fieldRules = {
        yearLevelId: "required",
      };
    }

    const errors = validate(fieldRules, form);
    if (!isEmpty(errors)) {
      return { error: true, ...errors };
    }

    return { error: false };
  };

  const formData = (form, type) => {
    if (["sync"].includes(type)) {
      return {
        elementId: form.elementId,
        yearLevelId: form.yearLevelId,
      };
    }

    return form;
  };

  const syncMarkingDataPeriodicalReportMarkingById = async (form = {}) => {
    const result = validateForm(form, "sync");
    if (result.error) {
      return result;
    }

    try {
      const data = formData(form, "sync");
      dispatch(
        toggleAlertInfo(
          true,
          "Syncing data",
          "Please wait as this may take a few minutes",
          "loading"
        )
      );
      const response = await syncMarkingDataPeriodicalReportMarkingByIdService(
        periodicalReportId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        setTimeout(() => {
          enqueueSnackbar("Data Synced successfully", {
            variant: "success",
          });
        }, 3000);
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setTimeout(() => {
        dispatch(toggleAlertInfo());
      }, 4000);
    }
  };

  const syncMarkingDataPeriodicalReportMarkingByIdAndAssessmentArea = async (
    assessmentAreaId
  ) => {
    try {
      dispatch(
        toggleAlertInfo(
          true,
          "Syncing data",
          "Please wait as this may take a few minutes",
          "loading"
        )
      );
      const response =
        await syncMarkingDataPeriodicalReportMarkingByIdAndAssessmentAreaService(
          periodicalReportId,
          assessmentAreaId
        );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        setTimeout(() => {
          enqueueSnackbar("Data Synced successfully", {
            variant: "success",
          });
        }, 3000);
        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setTimeout(() => {
        dispatch(toggleAlertInfo());
      }, 4000);
    }
  };

  return {
    syncMarkingDataPeriodicalReportMarkingById,
    syncMarkingDataPeriodicalReportMarkingByIdAndAssessmentArea,
  };
};

export default usePeriodicalReporMarking;
